import moment from "moment-timezone";
import { Timezones } from "@obby/constants";

export function UTCDate__GoogleCalendarFormattedDate(isoDate: string) {
  return moment(isoDate)
    .utc()
    .format("YYYYMMDD[T]HHmmss[Z]");
}
